namespace TabAurous.Inventory {
    export interface MeltingForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        DepartmentId: Serenity.LookupEditor;
        BaseItemTypeId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        CurrencyId: Serenity.IntegerEditor;
        ExchRate: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        Roundoff: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        EmployeeId: Serenity.IntegerEditor;
        AddressId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        ItemDetails: MeltingItemsEditor;
        RequiredAlloyTemp: Serenity.DecimalEditor;
        IssuedAlloy: Serenity.DecimalEditor;
        ReceivableWeight: Serenity.DecimalEditor;
        ReturnDetails: MeltingReturnItemsEditor;
        ReceivedWeight: Serenity.DecimalEditor;
        Loss: Serenity.DecimalEditor;
        LossPercent: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
    }

    export class MeltingForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.Melting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MeltingForm.init)  {
                MeltingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = LabelEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = MeltingItemsEditor;
                var w8 = MeltingReturnItemsEditor;

                Q.initFormType(MeltingForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'Posted', w2,
                    'VoucherNo', w0,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'DepartmentId', w5,
                    'BaseItemTypeId', w5,
                    'KaratId', w5,
                    'MetalColorId', w5,
                    'Purity', w6,
                    'CurrencyId', w3,
                    'ExchRate', w6,
                    'NetAmount', w6,
                    'Roundoff', w6,
                    'CompanyId', w3,
                    'BillNo', w0,
                    'BillDate', w1,
                    'ChallanNo', w0,
                    'ChallanDate', w1,
                    'EmployeeId', w3,
                    'AddressId', w3,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'FinancialYearId', w3,
                    'UserId', w3,
                    'ItemDetails', w7,
                    'RequiredAlloyTemp', w6,
                    'IssuedAlloy', w6,
                    'ReceivableWeight', w6,
                    'ReturnDetails', w8,
                    'ReceivedWeight', w6,
                    'Loss', w6,
                    'LossPercent', w6,
                    'Remark', w0
                ]);
            }
        }
    }
}
